import React from "react";
import { Box, Text } from "../../../../../designSystem";
import { Left, Right } from "../../styles";
import EditorArt from '../../../../../components/Images/EditorArt'

const BookModuleDiscovery = ({ user, bookDetails}) => {
    const { stats = {} } = bookDetails || {};
    const { published_chapter_count } = stats;

    const showUpsellDiv = user?.location === 'US' ?  published_chapter_count !== undefined && published_chapter_count < 10
    : published_chapter_count !== undefined && published_chapter_count < 5;
    const discoveryObj = {
        default : {
            condition:  published_chapter_count !== undefined && published_chapter_count < 5,
            'heading' : 'Please publish at least 5 chapters',
            'subText': 'Publishing 5 chapters of your book increases the visibility of your book, which will help it reach more readers.'
        },
        'US' : {
            condition:  published_chapter_count !== undefined && published_chapter_count < 10,
            'heading' : 'Publish 10 Chapters or More!',
            'subText': 'Boost your visibility in the app! Series with 10 or more chapters get prioritized exposure. Publish today and connect with even more listeners!'
        },
        'US10' : {
            condition:  published_chapter_count === 10,
            'heading' : 'Elevate Your Presence: Update Your Series Consistently!',
            'subText': 'Enhance your visibility within the app! When listeners encounter series of comparable quality, those updated regularly rise to the top. Stay consistent, and keep your audience engaged!'
        }
    }
    const resultObj = bookDetails.is_novel === 2 ? ( published_chapter_count !== undefined &&  published_chapter_count < 10 ? discoveryObj['US'] : discoveryObj['US10']) : discoveryObj['default']
    return (
        <>
            {resultObj?.condition && (
                <Box variant="flexCard" flexDirection={["column", "row"]} mb="8px">
                <Left>
                    <Text variant="heading" mb="8px">
                        {resultObj?.heading}
                    </Text>
                    <Text>
                        {resultObj?.subText}
                    </Text>
                </Left>
                <Right>
                    <EditorArt />
                </Right>
                </Box>
            )}
        </>
    )
}
export default BookModuleDiscovery